import { render, staticRenderFns } from "./products-collections.vue?vue&type=template&id=070faaa4&scoped=true&"
import script from "./products-collections.vue?vue&type=script&lang=js&"
export * from "./products-collections.vue?vue&type=script&lang=js&"
import style0 from "./products-collections.vue?vue&type=style&index=0&id=070faaa4&scoped=true&lang=css&"
import style1 from "./products-collections.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070faaa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070faaa4')) {
      api.createRecord('070faaa4', component.options)
    } else {
      api.reload('070faaa4', component.options)
    }
    module.hot.accept("./products-collections.vue?vue&type=template&id=070faaa4&scoped=true&", function () {
      api.rerender('070faaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/products-collections.vue"
export default component.exports